export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["需要确认"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["授权需要一次性密钥确认"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["授权需要魔法词确认"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["注册需要短信码确认"])}
}